import { Field, ErrorMessage } from "formik"

interface InputInterface {
    name: string,
    title?: string,
    type: 'number' | 'text' | 'email' | 'password',
    min?: number,
    max?: number,
    id?: string,
    classes?: string,
    label?: string,
    placeholder?: string,
    disabled?: boolean
}

const Input = ({name, type, id, classes, min, max, label, placeholder, title, disabled}: InputInterface) => {
    return <div className={`d--flex flex-column ${classes ?? ""}`}>
        <label className="mb-8" htmlFor={id ?? name}>{label}</label>
        <Field
            className="m-0"
            id={id ?? name}
            name={name}
            title={title}
            type={type}
            min={min}
            max={max}
            placeholder={placeholder}
            disabled={disabled}
        />
        <ErrorMessage component={"div"} name={name} className={"m-0 configurator-content__error rte links-underline"}></ErrorMessage>
    </div>
}

export default Input